import React from "react";

interface Task {
  id: string;
  agentName: string;
  message: string;
  timestamp: number;
}

interface TimelineProps {
  tasks: Task[];
}

//h-[calc(100vh-120px)]

const Timeline: React.FC<TimelineProps> = ({ tasks }) => {
  return (
    // <div className="flex-1 flex flex-col gap-6 p-6 bg-charcoal overflow-y-auto min-h-0">
    <div className="flex-1 flex flex-col gap-6 p-6 bg-charcoal overflow-y-auto min-h-0">
      {tasks.map((task) => (
        <div
          key={task.id}
          className="rounded-xl border border-darkgray bg-secondary p-5 shadow-sm hover:shadow-md transition-shadow"
        >
          <div className="text-xs text-gray-400 mb-1">
            {new Date(task.timestamp).toLocaleString()}
          </div>
          <div className="text-sm font-medium text-offwhite">
            {task.agentName}
          </div>
          <div className="mt-2 text-sm text-offwhite whitespace-pre-line">
            {task.message}
          </div>
        </div>
      ))}
      <div id="timeline-end" />
    </div>
  );
};

export default Timeline;
